import { fileOpen } from "browser-fs-access"; // Used for file picker


const addSignature = async (token, prefix) => {
  const file = await fileOpen({
    description: "Sélectionner le fichier de signature (.jpg, .png)",
    mimeTypes: ["image/jpeg", "image/png"],
  });
  if (file === null) {
    return false;
  }
  const formData = new FormData();
  formData.append("file", file);
  const url = `${prefix}rtb/add_signature`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Failed to add signature");
    }
    // get response "success" field which is a boolean
    const responseData = await response.json();
    return responseData.success;
  } catch (error) {
    console.error("Error adding signature:", error);
    throw error;
  }
};

export default addSignature;